module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-2400.5a886e7a.svg";